
import { Container, Tab, Nav, Form, Button, Modal, InputGroup, Dropdown, Tooltip, OverlayTrigger, Card } from "react-bootstrap";

import axios from 'axios';
import { useProfile } from "../contexts/ProfileContext";
import { useLang, useLanguage } from "../contexts/LanguageContext";
import { useEffect } from "react";
import InputMask from 'react-input-mask';
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";
import Alert from "./Alert";
import injectCollectJS from '../injectCollect';
import RegisterSocial from './RegisterSocial';




const Settings = () => {
	const navigate = useNavigate();
  // State for Profile tab
  const profile = useProfile();
  const { lang, setLang } = useLang();
  const L = useLanguage();
  const [language, setLanguage] = useState(profile.language || lang);
  const [email, setEmail] = useState(profile.email);
  const isDeletedAccount = profile.email?.toLowerCase().startsWith("deleted-");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const needsPasswordSetup = profile.passwordReset === true;

  const defaultPhoto = "/images/default.png";

  //For paying invoices
  const [showPayInvoiceModal, setShowPayInvoiceModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const cardRef = useRef(null);
  const expRef = useRef(null);
  const cvvRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const mountedRef = useRef(true);
  const [isReinitializingCollect, setIsReinitializingCollect] = useState(false);



  const [instagram, setInstagram] = useState(profile.instagram);

  // State for Billing tab
  const [cardNumber, setCardNumber] = useState("");
  const [cardExpiry, setCardExpiry] = useState(profile.exp);
  const [cardCvc, setCardCvc] = useState("***");


  const [nextRenewalDate, setNextRenewalDate] = useState("");
  // State for Modals
  const [showModal, setShowModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const [cancelReasonType, setCancelReasonType] = useState("");
  const [selectedProfileId, setSelectedProfileId] = useState("");
  // Handlers for modals
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [cancelSubInterval, setCancelSubInterval] = useState(null);
  const [cancelSubPlan, setCancelSubPlan] = useState(null);
  const [switchingToMonthly, setSwitchingToMonthly] = useState(false);

  const handleOpenCancelModal = (subscriptionid, planInterval, planName) => {
    setSelectedSubscriptionId(subscriptionid);
    setCancelSubInterval(planInterval);
    setCancelSubPlan(planName);
    setCancelReason("");
    setCancelReasonType("");
    setShowCancelModal(true);
  };
  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
    setCancelReason("");
    setSelectedSubscriptionId(null);
    setCancelSubInterval(null);
    setCancelSubPlan(null);
    setCancelReasonType("");
  };

  const handleSwitchToMonthly = async () => {
    setSwitchingToMonthly(true);
    try {
      await axios.post("https://api.viralgpt.com/purchase/change-plan", {
        newPlan: cancelSubPlan,
        newInterval: "monthly",
      }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
      setFunctionSuccess(L.settings.switchedToMonthly);
      handleCloseCancelModal();
      window.location.reload();
    } catch (error) {
      setFunctionError(error.response?.data?.error || L.settings.errorSwitchingMonthly);
    } finally {
      setSwitchingToMonthly(false);
    }
  };

  const handleAccidentalAnnualSwitch = async () => {
    setSwitchingToMonthly(true);
    try {
      const token = localStorage.getItem('accessToken');
      // Decode JWT to get userId
      const payload = JSON.parse(atob(token.split('.')[1]));
      const userId = payload.userId || payload.userid || payload.id;
      // Find original transaction
      const lookupResp = await axios.post("https://api.viralgpt.com/refund/lookup", {
        email: payload.email
      });
      const originalTx = lookupResp.data.transactions?.find(tx => tx.transaction_type === 'subcharge');
      if (!originalTx) { setFunctionError(L.settings.couldNotFindTransaction); return; }

      const resp = await axios.post("https://api.viralgpt.com/refund/switch-to-monthly", {
        userid: userId,
        transactionid: originalTx.transactionid
      });
      setFunctionSuccess(L.settings.refundedAndSwitched(resp.data.refundAmount, resp.data.newMonthlyPrice, new Date(resp.data.nextChargeDate).toLocaleDateString()));
      handleCloseCancelModal();
      window.location.reload();
    } catch (error) {
      setFunctionError(error.response?.data?.error || L.settings.errorProcessingSwitch);
    } finally {
      setSwitchingToMonthly(false);
    }
  };

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const handleOpenChangePasswordModal = () => setShowChangePasswordModal(true);
  const handleCloseChangePasswordModal = () => setShowChangePasswordModal(false);

  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");

  const handleSubmitPasswordChange = async () => {
	if (newPassword !== confirmPassword) {
		setFunctionError(L.settings.passwordsDoNotMatch);
		return;
	}
    try {
      const response = await axios.post("https://api.viralgpt.com/auth/settings", {
        // Passwordless one-time buyers have no current password to enter.
        // The authenticated settings endpoint verifies this sentinel server-side.
        oldPassword: needsPasswordSetup ? 'no-password' : oldPassword,
        newPassword: newPassword
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });

	  if (response.data.changes.password) {
		setFunctionSuccess(L.settings.passwordUpdated);
		setShowChangePasswordModal(false);
		setOldPassword("");
		setNewPassword("");
	  } else {
		setFunctionError(L.settings.passwordNotUpdated);
	  }
     
    } catch (e) {
      if (e.response?.data?.error) {
        setFunctionError(e.response.data.error);
      } else {
        setFunctionError(L.settings.errorUpdatingPassword);
      }
    }
  }

  // Handlers
  const handleSaveProfile = async () => {
    try {
		if (newPassword !== confirmPassword) {
			setFunctionError(L.settings.passwordsDoNotMatch);
			return;
		}

      const x = await axios.post("https://api.viralgpt.com/auth/settings", {
        email: email,
        oldPassword: oldPassword,
        newPassword: newPassword,
        language: language
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });
      setLang(language);
      setFunctionSuccess(L.settings.profileUpdated);
    } catch (e) {
      setFunctionError(L.settings.errorUpdatingProfile);
    }
  };

  const [isAddingCard, setIsAddingCard] = useState(false);

  const handleSaveBilling = async () => {
    console.log("Billing info saved:", {
      cardNumber,
      cardExpiry,
      cardCvc,
    });
    try {
      setIsAddingCard(true);
      const x = await axios.post("https://api.viralgpt.com/purchase/add-card", {
        card: cardNumber,
        exp: cardExpiry,
        cvv: cardCvc,
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });
	  /*axios.post("https://api.viralgpt.com/pixel", {
		email: profile.email,
		event: "AddPaymentInfo",
		price: 0
	}, {
		withCredentials: true
	  })*/
      setFunctionSuccess(L.settings.billingUpdated);
	  window.location.reload();
	  setIsAddingCard(false);
    } catch (error) {
      setFunctionError(error.response.data.error);
	  setIsAddingCard(false);
    }
  };

  useEffect(() => {
	var price = parseFloat(selectedInvoice?.price || 0);
	setIsReinitializingCollect(true);
	console.log('Reinitializing CollectJS with price:', price.toString());
	const timeoutId = setTimeout(() => {
		if (!mountedRef.current) return;
		try {
			injectCollectJS('https://secure.nmi.com/token/Collect.js', '9t4q59-U47k7W-Cj7Ty9-MbC6Y6', handlePayInvoiceApplePay, price.toString())
				.then(() => {
					if (!mountedRef.current) return;
					console.log('CollectJS reinitialized successfully with price:', price.toString());
					setIsReinitializingCollect(false);
				})
				.catch((error) => {
					if (!mountedRef.current) return;
					console.error('Error initializing CollectJS:', error);
					setIsReinitializingCollect(false);
				});
		} catch (error) {
			if (!mountedRef.current) return;
			console.error('Error calling injectCollectJS:', error);
			setIsReinitializingCollect(false);
		}
	}, 300);
	return () => { clearTimeout(timeoutId); };
  }, [selectedInvoice]);


  const handleCancelSubscription = () => {
    console.log("Subscription cancelled");
    handleCloseCancelModal();
	try {
		const cancelSubscription = axios.post("https://api.viralgpt.com/purchase/cancel", {}, {
			headers:{ 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }
		})
		setFunctionSuccess(L.settings.subscriptionCancelled);
	} catch (e) {
		console.error(e)
	}
  };

const getRenewalDate = async () => {
	try {
		const renewalDate = await axios.post("https://api.viralgpt.com/purchase/renewal-date", {}, {
			headers:{ 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }
		});
		if (renewalDate.status == 200) {
			setNextRenewalDate(renewalDate.data.nextChargeDate);
		} else {
			setNextRenewalDate("No active subscription");
		}
	} catch (error) {
		console.error("Error fetching renewal date:", error);
		setNextRenewalDate("No active subscription");
	}
}

const handleCardChange = async (profileid, cardid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/link-card", {
			profileid: profileid, cardid: cardid
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		/*axios.post("https://api.viralgpt.com/pixel", { email: profile.email, event: "AddPaymentInfo", price: 0 }, { withCredentials: true })*/
		setFunctionSuccess(L.settings.linkedCardChanged);
		window.location.reload();
	} catch (error) {
		setFunctionError(L.settings.errorLinkingCard);
	}
}

const deleteCard = async (profileid, cardid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/delete-card", {
			profileid: profileid, cardid: cardid
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.cardDeleted);
		window.location.reload();
	} catch (error) {
		setFunctionError(L.settings.errorDeletingCard);
	}
}

const handlePauseSubscription = async (subscriptionid) => {
	if (cancelReasonType === "other" && cancelReason.length < 15) {
		setFunctionError(L.settings.provideReason);
		return;
	}
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/cancel", {
			subscriptionid: subscriptionid,
			reason: cancelReasonType === "other" ? cancelReason : cancelReasonType
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.subscriptionPaused);
		handleCloseCancelModal();
		window.location.reload();
	} catch (error) {
		setFunctionError(L.settings.errorPausingSubscription);
	}
}

const handleResumeSubscription = async (subscriptionid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/purchase/resume", {
			subscriptionid: subscriptionid
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.subscriptionResumed);
		window.location.reload();
	} catch (error) {
		setFunctionError(L.settings.errorResumingSubscription);
	}
}

// Auto-refill cancel/resume. One call, no reason collected: the server refuses
// to record a local cancel the gateway did not accept, so a success here means
// the billing really has stopped.
const handleCancelAutoRefill = async () => {
	if (!window.confirm(L.settings.autoRefillConfirm)) return;
	setAutoRefillLoading(true);
	try {
		await axios.post("https://api.viralgpt.com/purchase/refill/cancel", {},
			{ headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.autoRefillCanceledOk);
		window.location.reload();
	} catch (error) {
		setFunctionError(error.response?.data?.error || L.settings.autoRefillError);
		setAutoRefillLoading(false);
	}
}

const handleResumeAutoRefill = async () => {
	setAutoRefillLoading(true);
	try {
		await axios.post("https://api.viralgpt.com/purchase/refill/resume", {},
			{ headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.autoRefillResumedOk);
		window.location.reload();
	} catch (error) {
		setFunctionError(error.response?.data?.error || L.settings.autoRefillError);
		setAutoRefillLoading(false);
	}
}

const handlePayInvoiceApplePay = async (paymenttoken) => {
	setIsLoading(true);
	try {
	  const response = await axios.post("https://api.viralgpt.com/purchase/pay-invoice", {
		  invoiceid: selectedInvoice?.invoiceid, paymenttoken: paymenttoken
	  }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
	  setFunctionSuccess(L.settings.invoicePaid);
	  window.location.reload();
	} catch (error) {
	  setFunctionError(L.settings.errorPayingInvoice);
	} finally {
	  setIsLoading(false);
	}
}

const handlePayInvoice = async (invoiceid, cardid, exp, cvv, card) => {
  setIsLoading(true);
  try {
	let data;
	if (cardid == "addCard") {
		data = { invoiceid, exp, cvv, card }
	} else {
		data = { invoiceid, cardid }
	}
    const response = await axios.post("https://api.viralgpt.com/purchase/pay-invoice", data, {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }
    });
	setFunctionSuccess(L.settings.invoicePaid);
	window.location.reload();
  } catch (error) {
    setFunctionError(L.settings.errorPayingInvoice);
  } finally {
    setIsLoading(false);
  }
}

const unlinkAccount = async (profileid) => {
	try {
		const response = await axios.post("https://api.viralgpt.com/auth/unlink", {
			profileid: profileid
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.accountUnlinked);
		window.location.reload();
	} catch (error) {
		setFunctionError(error.response.data.error);
	}
}

const [pauseLoadingId, setPauseLoadingId] = useState(null);
const [autoRefillLoading, setAutoRefillLoading] = useState(false);

const handleToggleGrowthPause = async (profileid, currentlyPaused) => {
	setPauseLoadingId(profileid);
	try {
		const response = await axios.post("https://api.viralgpt.com/auth/profile/pause", {
			profileid: profileid,
			paused: !currentlyPaused
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(response.data.message);
		window.location.reload();
	} catch (error) {
		setFunctionError(error.response?.data?.error || L.settings.errorUpdatingGrowth);
	} finally {
		setPauseLoadingId(null);
	}
};

const [showUnlinkModal, setShowUnlinkModal] = useState(false);
const [unlinkProfile, setUnlinkProfile] = useState(null);
const [unlinkProfileName, setUnlinkProfileName] = useState(null);

const [showAddProfile, setShowAddProfile] = useState(false);

const handleFreeBalance = async () => {
	try {
		const response = await axios.post("https://api.viralgpt.com/winback", {
			profileid: profile.selectedProfile
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		setFunctionSuccess(L.settings.freeBalanceAdded);
	} catch (error) {
		setFunctionError(error.response.data.error);
	}
}

const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const modeParam = queryParams.get("tab");
const validModes = ["billing", "profile", "invoices", "refills"];
const defaultKey = validModes.includes(modeParam) ? modeParam : "profile";
const [activeTab, setActiveTab] = useState(defaultKey);

const handleTabSelect = (key) => {
	setActiveTab(key);
	navigate(`/dashboard/settings?tab=${key}`, { replace: true });
};
  
const [missingFollowers, setMissingFollowers] = useState(null);
const [profilePhotoMissing, setProfilePhotoMissing] = useState(false);
const [currentFollowers, setCurrentFollowers] = useState(0);
const [expectedFollowers, setExpectedFollowers] = useState(0);
// Whether a refill can actually be claimed. The package-buyer scan reports it
// (an order still filling, or a gap inside normal churn, is not claimable);
// the subscriber scan does not send the field, and undefined must keep the old
// always-claimable behaviour rather than disabling their button.
const [refillEligible, setRefillEligible] = useState(undefined);
const [deliveredFollowers, setDeliveredFollowers] = useState(0);
const [showRequestRefillModal, setShowRequestRefillModal] = useState(false);
const [requestRefillProfileId, setRequestRefillProfileId] = useState(null);
const [isScanning, setIsScanning] = useState(false);
const [isSubmittingRefill, setIsSubmittingRefill] = useState(false);

const handleRequestRefill = async (profileid) => {
	if (isSubmittingRefill) return;
	setIsSubmittingRefill(true);
	try {
		const response = await axios.post("https://api.viralgpt.com/refill/scan", {
			platform: profile.socials[profileid].platform,
			username: profile.socials[profileid].username,
			profileid: profileid, mode: "request"
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		if (response.data.error) { setFunctionError(response.data.error); return; }
		// The amount the server placed, not a component state that was never set
		// on this path — a package buyer was told "undefined followers will be
		// delivered" for a refill that had not been ordered at all.
		const ordered = response.data.ordered ?? missingFollowers;
		setFunctionSuccess(L.settings.refillSubmitted(Number(ordered || 0).toLocaleString()));
		handleLookupRefill(profileid);
	} catch (error) {
		setFunctionError(L.settings.errorSubmittingRefill);
	} finally {
		setIsSubmittingRefill(false);
	}
}	

const handleLookupRefill = async (profileid) => {
	setIsScanning(true);
	try {
		const response = await axios.post("https://api.viralgpt.com/refill/scan", {
			platform: profile.socials[profileid].platform,
			username: profile.socials[profileid].username,
			profileid: profileid, mode: "lookup"
		}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') } });
		if (response.data.error) {
			setFunctionError(response.data.error);
			return;
		}
		setMissingFollowers(Number(response.data.missingFollowers ?? 0));
		setProfilePhotoMissing(response.data.photo);
		setCurrentFollowers(response.data.currentFollowers || 0);
		setExpectedFollowers(response.data.expectedFollowers || 0);
		setDeliveredFollowers(Number(response.data.delivered) || 0);
		setRefillEligible(response.data.eligible);
		if (response.data.missingFollowers !== undefined && parseInt(response.data.missingFollowers) > 0) {
			setFunctionError(L.settings.scannedMissing(response.data.missingFollowers));
		} else {
			setFunctionSuccess(L.settings.scannedNoMissing);
		}
	} catch (error) {
		setFunctionError(error.response?.data?.error || L.settings.noFollowersDelivered);
	} finally {
		setIsScanning(false);
	}
}

  // Stripe-style inline helpers
  const stripeCard = { background: '#fff', borderRadius: '12px', border: '1px solid #e3e8ee', overflow: 'hidden' };
  const stripeCardHeader = { borderBottom: '1px solid #e3e8ee', padding: '14px 20px' };
  const stripeHeaderText = { fontWeight: 600, color: '#0a2540', fontSize: '0.95rem', margin: 0 };
  const stripeLabel = { fontSize: '0.78rem', fontWeight: 600, color: '#425466', textTransform: 'uppercase', letterSpacing: '0.05em' };
  const stripePurple = '#635bff';
  const stripeInput = { borderRadius: '8px', border: '1px solid #e3e8ee', padding: '10px 14px', fontSize: '0.95rem', color: '#0a2540' };
  const stripeBtn = { background: stripePurple, color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 20px', fontSize: '0.875rem', fontWeight: 600 };
  const stripeBtnLight = { borderRadius: '8px', padding: '8px 20px', fontSize: '0.875rem', fontWeight: 600, color: '#425466', border: '1px solid #e3e8ee', background: '#fff' };

  return (
    <>
      <div style={{background: '#f6f9fc', minHeight: '100vh'}}>
      <Container className="py-5" style={{maxWidth: '860px'}}>
        {/* Page Header */}
        <div className="mb-5">
          <h1 className="mb-1" style={{fontSize: '1.75rem', fontWeight: 700, color: '#0a2540', letterSpacing: '-0.02em'}}>{L.settings.title}</h1>
          <p style={{color: '#425466', fontSize: '0.95rem', margin: 0}}>{L.settings.subtitle}</p>
        </div>

        <Alert variant="danger" message={functionError} show={!!functionError} onClose={() => setFunctionError("")} />
        <Alert variant="success" message={functionSuccess} show={!!functionSuccess} onClose={() => setFunctionSuccess("")} />
		
        <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
          {/* Stripe-style tab navigation */}
          <div className="mb-4">
            <Nav className="d-flex gap-1 p-1" style={{background: '#edf0f3', borderRadius: '10px', border: 'none'}}>
              {[
                {key: 'profile', label: L.settings.tabs.profile, icon: 'fa-user'},
                {key: 'billing', label: L.settings.tabs.billing, icon: 'fa-credit-card'},
                {key: 'invoices', label: L.settings.tabs.invoices, icon: 'fa-file-invoice'},
                {key: 'refills', label: L.settings.tabs.refills, icon: 'fa-redo'}
              ].map(tab => (
                <Nav.Item key={tab.key} className="flex-fill text-center">
                  <Nav.Link eventKey={tab.key} className="border-0 py-2 px-3" style={{
                    borderRadius: '8px', fontSize: '0.875rem', fontWeight: 600,
                    color: activeTab === tab.key ? '#0a2540' : '#68778d',
                    background: activeTab === tab.key ? '#fff' : 'transparent',
                    boxShadow: activeTab === tab.key ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
                    transition: 'all 0.15s ease'
                  }}>
                    <i className={`fas ${tab.icon} me-2`} style={{fontSize: '0.8rem'}}></i>{tab.label}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </div>

          <Tab.Content>

            {/* ===================== ACCOUNT TAB ===================== */}
            <Tab.Pane eventKey="profile">
              {/* Account Info */}
              <div className="mb-4" style={{...stripeCard, ...(isDeletedAccount ? {opacity: 0.5, pointerEvents: 'none'} : {})}}>
                <div style={stripeCardHeader}>
                  <h6 style={stripeHeaderText}><i className="fas fa-user-circle me-2" style={{color: stripePurple}}></i>{L.settings.accountInformation}</h6>
                  {isDeletedAccount && <span style={{fontSize: '0.8rem', color: '#cf3033', fontWeight: 500}}>{L.settings.accountDeleted}</span>}
                </div>
                <div className="p-4">
                  <Form autoComplete="off">
                    <Form.Group className="mb-3">
                      <Form.Label style={stripeLabel}>{L.settings.emailAddress}</Form.Label>
                      <Form.Control type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={L.settings.enterYourEmail} style={stripeInput} disabled={isDeletedAccount} />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label style={stripeLabel}>{L.settings.preferredLanguage}</Form.Label>
                      <Form.Select value={language} onChange={(e) => setLanguage(e.target.value)} style={stripeInput} disabled={isDeletedAccount}>
                        <option value="en">English</option>
                        <option value="es">Español</option>
                      </Form.Select>
                    </Form.Group>
                    <div className="d-flex gap-2">
                      <Button onClick={handleSaveProfile} style={stripeBtn} disabled={isDeletedAccount}>{L.settings.saveChanges}</Button>
                      <Button variant="light" onClick={handleOpenChangePasswordModal} style={stripeBtnLight} disabled={isDeletedAccount}>
						<i className="fas fa-lock me-2" style={{fontSize: '0.75rem'}}></i>{needsPasswordSetup ? L.dashboard.setPassword : L.settings.changePassword}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>

              {/* Linked Profiles */}
              <div style={stripeCard}>
                <div style={stripeCardHeader}>
                  <h6 style={stripeHeaderText}><i className="fas fa-link me-2" style={{color: stripePurple}}></i>{L.settings.linkedProfiles}</h6>
                </div>
                <div className="p-4">
                  <div className="d-flex flex-column gap-3">
                    {Object.values(profile.socials).map((social, index) => (
                      <div key={index} className="d-flex align-items-center justify-content-between p-3" style={{background: '#f6f9fc', borderRadius: '10px', border: '1px solid #e3e8ee'}}>
                        <div className="d-flex align-items-center gap-3">
                          <img src={social.photo || defaultPhoto} alt={social.username} className="rounded-circle" style={{width: '44px', height: '44px', objectFit: 'cover', border: '2px solid #e3e8ee'}} onError={(e) => { e.target.onerror = null; e.target.src = '/images/default.png'; }} />
                          <div>
                            <div style={{fontWeight: 600, color: '#0a2540', fontSize: '0.9rem'}}>{social.username}</div>
                            <div className="d-flex align-items-center gap-1" style={{fontSize: '0.8rem', color: '#68778d'}}>
                              {social.platform === 'instagram' && <><i className="fab fa-instagram text-pink-500"></i> Instagram</>}
                              {social.platform === 'tiktok' && <><i className="fab fa-tiktok"></i> TikTok</>}
                              {social.platform === 'youtube' && <><i className="fab fa-youtube text-red-500"></i> YouTube</>}
                              {social.platform === 'x' && <><span className="bg-black px-1 rounded text-white" style={{fontSize: '0.65rem'}}>𝕏</span> Twitter</>}
                            </div>
                          </div>
                        </div>
                        <button className="btn btn-sm d-flex align-items-center gap-1" style={{color: '#cf3033', fontSize: '0.8rem', fontWeight: 500, background: 'transparent', border: '1px solid #fecaca', borderRadius: '6px', padding: '4px 12px'}}
                          onClick={() => { setShowUnlinkModal(true); setUnlinkProfile(social.profileid); setUnlinkProfileName(social.username); }}>
                          <i className="fas fa-unlink" style={{fontSize: '0.65rem'}}></i> {L.settings.unlink}
                        </button>
                      </div>
                    ))}
                  </div>

                  {/* Add Another Profile */}
                  <button className="d-flex align-items-center gap-2 mt-3 w-100 justify-content-center p-3"
                    onClick={() => setShowAddProfile(true)}
                    style={{background: '#fff', borderRadius: '10px', border: '1px dashed #c1c9d2', color: '#68778d', fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', transition: 'all 0.15s ease'}}>
                    <i className="fas fa-plus" style={{color: stripePurple, fontSize: '0.75rem'}}></i>
                    {L.settings.addAnotherProfile}
                  </button>
                </div>
              </div>
            </Tab.Pane>

            {/* ===================== BILLING TAB ===================== */}
            <Tab.Pane eventKey="billing">

              {/* Payment Methods Card */}
              <div className="mb-4" style={stripeCard}>
                <div className="d-flex justify-content-between align-items-center" style={stripeCardHeader}>
                  <h6 style={stripeHeaderText}><i className="fas fa-credit-card me-2" style={{color: stripePurple}}></i>{L.settings.paymentMethods}</h6>
                  {Object.keys(profile.cards).length > 0 && (
                    <Button size="sm" onClick={handleOpenModal} style={{...stripeBtn, padding: '6px 14px', fontSize: '0.8rem'}}>
                      <i className="fas fa-plus me-1"></i> {L.settings.addCard}
                    </Button>
                  )}
                </div>
                <div className="p-4">
                  {Object.keys(profile.cards).length > 0 ? (
                    <div className="d-flex flex-column gap-2">
                      {Object.values(profile.cards).map((card, index) => (
                        <div key={index} className="d-flex justify-content-between align-items-center p-3" style={{background: '#f6f9fc', borderRadius: '10px', border: '1px solid #e3e8ee'}}>
                          <div className="d-flex align-items-center gap-3">
                            <div style={{width: '40px', height: '28px', background: '#fff', borderRadius: '6px', border: '1px solid #e3e8ee', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                              {card.cardnumber.startsWith('3') && <i className="fab fa-cc-amex" style={{color: '#006fcf', fontSize: '1.2rem'}}></i>}
                              {card.cardnumber.startsWith('4') && <i className="fab fa-cc-visa" style={{color: '#1a1f71', fontSize: '1.2rem'}}></i>}
                              {card.cardnumber.startsWith('5') && <i className="fab fa-cc-mastercard" style={{color: '#eb001b', fontSize: '1.2rem'}}></i>}
                              {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fas fa-credit-card" style={{color: '#68778d', fontSize: '1rem'}}></i>}
                            </div>
                            <div>
                              <div style={{fontWeight: 600, color: '#0a2540', fontSize: '0.9rem'}}>•••• •••• •••• {card.cardnumber.slice(-4)}</div>
                              <div style={{fontSize: '0.78rem', color: '#68778d'}}>{L.settings.expires(card.exp)}</div>
                            </div>
                          </div>
                          <OverlayTrigger placement="top" overlay={
                            <Tooltip>{Object.values(profile.socials).some(s => s.cardid == card.cardid) ? L.settings.linkedToActiveSub : L.settings.deleteCard}</Tooltip>
                          }>
                            <span>
                              <button className="btn btn-sm" disabled={Object.values(profile.socials).some(s => s.cardid == card.cardid)}
                                onClick={() => { if (!Object.values(profile.socials).some(s => s.cardid == card.cardid)) deleteCard(profile.profileid, card.cardid); }}
                                style={{color: Object.values(profile.socials).some(s => s.cardid == card.cardid) ? '#c1c9d2' : '#cf3033', border: '1px solid #e3e8ee', borderRadius: '6px', padding: '4px 10px', fontSize: '0.8rem'}}>
                                <i className="fas fa-trash"></i>
                              </button>
                            </span>
                          </OverlayTrigger>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label style={stripeLabel}><i className="far fa-credit-card me-2"></i>{L.settings.cardNumber}</Form.Label>
                        <Form.Control type="text" name="cc-number" autoComplete="cc-number" inputMode="numeric" placeholder="1234 5678 9012 3456" value={cardNumber}
                          onChange={(e) => { let v = e.target.value.replace(/\D/g, ""); v = v.replace(/(.{4})/g, "$1 ").trim(); setCardNumber(v); }} style={stripeInput} />
                      </Form.Group>
                      <div className="row">
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label style={stripeLabel}><i className="far fa-calendar me-2"></i>{L.settings.expiration}</Form.Label>
                            <Form.Control as={InputMask} maskChar="" type="text" placeholder="MM/YY" mask="99/99" value={cardExpiry} onChange={(e) => setCardExpiry(e.target.value)} style={stripeInput} />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3">
                            <Form.Label style={stripeLabel}><i className="fas fa-lock me-2"></i>{L.settings.cvc}</Form.Label>
                            <Form.Control as={InputMask} maskChar="" type="text" placeholder="•••" mask="999" value={cardCvc} onChange={(e) => setCardCvc(e.target.value)} style={stripeInput} />
                          </Form.Group>
                        </div>
                      </div>
                      <Button onClick={handleSaveBilling} style={stripeBtn}><i className="fas fa-plus me-2"></i>{L.settings.addCard}</Button>
                    </Form>
                  )}
                </div>
              </div>

              {/* Auto-refill. Its own card and its own cancel: one click, no
                  reason demanded. The Subscriptions cancel flow below only
                  reveals its confirm button for the "Other" reason and wants 15
                  characters of prose first — for a recurring charge the buyer
                  did not go looking for, a cancel that cannot be completed is
                  the most disputable thing on the page. */}
              {profile.autoRefill && (
                <div style={stripeCard}>
                  <div style={stripeCardHeader}>
                    <h6 style={stripeHeaderText}><i className="fas fa-rotate me-2" style={{color: stripePurple}}></i>{L.settings.autoRefillTitle}</h6>
                  </div>
                  <div className="p-4">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                      <div>
                        <div style={{fontWeight: 600, color: '#0a2540', fontSize: '0.95rem'}}>
                          ${Number(profile.autoRefill.amount).toFixed(2)}
                          <span style={{color: '#68778d', fontWeight: 500, fontSize: '0.85rem'}}>
                            {' '}{L.settings.autoRefillEvery(profile.autoRefill.day_frequency)}
                          </span>
                        </div>
                        <div style={{color: '#68778d', fontSize: '0.82rem', marginTop: 2}}>
                          {profile.autoRefill.status === 'canceled'
                            ? L.settings.autoRefillCanceled
                            : profile.autoRefill.next_bill_at
                              ? L.settings.autoRefillNext(new Date(profile.autoRefill.next_bill_at).toLocaleDateString())
                              : L.settings.autoRefillActive}
                        </div>
                      </div>
                      {profile.autoRefill.status === 'canceled' ? (
                        <button
                          className="btn btn-sm d-flex align-items-center"
                          onClick={handleResumeAutoRefill}
                          disabled={autoRefillLoading}
                          style={{background: '#059669', color: '#fff', border: 'none', borderRadius: '6px', padding: '5px 12px', fontSize: '0.8rem', fontWeight: 600}}
                        >
                          <i className={`fas ${autoRefillLoading ? 'fa-spinner fa-spin' : 'fa-play'} me-1`}></i> {L.settings.autoRefillResume}
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm d-flex align-items-center"
                          onClick={handleCancelAutoRefill}
                          disabled={autoRefillLoading}
                          style={{color: '#cf3033', fontSize: '0.8rem', fontWeight: 500, background: 'transparent', border: '1px solid #fecaca', borderRadius: '6px', padding: '5px 12px'}}
                        >
                          <i className={`fas ${autoRefillLoading ? 'fa-spinner fa-spin' : 'fa-times'} me-1`}></i> {L.settings.autoRefillCancel}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Subscriptions */}
              <div style={stripeCard}>
                <div style={stripeCardHeader}>
                  <h6 style={stripeHeaderText}><i className="fas fa-receipt me-2" style={{color: stripePurple}}></i>{L.settings.subscriptions}</h6>
                </div>
                <div className="p-4 d-flex flex-column gap-3">
                  {Object.values(profile.socials).map((social, index) => (
                    <div key={index} style={{background: '#f6f9fc', borderRadius: '12px', border: '1px solid #e3e8ee', overflow: 'hidden'}}>
                      {/* Subscription header */}
                      <div className="d-flex align-items-center gap-3 p-3" style={{borderBottom: '1px solid #e3e8ee'}}>
                        <img src={social.photo || defaultPhoto} alt={social.username} className="rounded-circle" style={{width: '48px', height: '48px', objectFit: 'cover', border: '2px solid #e3e8ee'}} onError={(e) => { e.target.onerror = null; e.target.src = '/images/default.png'; }} />
                        <div className="flex-grow-1">
                          <div className="d-flex align-items-center gap-2">
                            <span style={{fontWeight: 600, color: '#0a2540', fontSize: '0.95rem'}}>
                              {social.platform === 'instagram' && <i className="fab fa-instagram text-pink-500 me-1"></i>}
                              {social.platform === 'tiktok' && <i className="fab fa-tiktok me-1"></i>}
                              {social.platform === 'youtube' && <i className="fab fa-youtube text-red-500 me-1"></i>}
                              {social.platform === 'x' && <span className="bg-black px-1 rounded text-white me-1" style={{fontSize: '0.6rem'}}>𝕏</span>}
                              {social.username}
                            </span>
                          </div>
                          <div className="d-flex align-items-center gap-2 mt-1">
                            <span style={{
                              fontSize: '0.7rem', fontWeight: 600, padding: '2px 8px', borderRadius: '4px',
                              background: social.endDate ? '#fef2f2' : social.status === 'active' ? '#ecfdf5' : '#f3f4f6',
                              color: social.endDate ? '#991b1b' : social.status === 'active' ? '#065f46' : '#6b7280'
                            }}>
                              {(social.endDate ? L.settings.cancelled : social.status || L.settings.inactive).toUpperCase()}
                            </span>
                            {social.planName && (
                              <span style={{
                                fontSize: '0.7rem', fontWeight: 600, padding: '2px 8px', borderRadius: '4px',
                                background: social.planName === 'pro' ? '#f0ebff' : social.planName === 'basic' ? '#f0f4ff' : '#f3f4f6',
                                color: social.planName === 'pro' ? '#5b21b6' : social.planName === 'basic' ? '#1e40af' : '#6b7280'
                              }}>
                                {(social.planName || L.settings.noPlan).toUpperCase()}
                              </span>
                            )}
                            {social.isPaused === 'true' && (
                              <span style={{
                                fontSize: '0.7rem', fontWeight: 600, padding: '2px 8px', borderRadius: '4px',
                                background: '#fef3c7', color: '#92400e'
                              }}>
                                {L.settings.growthPaused}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Subscription details */}
                      <div className="p-3">
                        <div className="row" style={{fontSize: '0.85rem', color: '#425466'}}>
                          <div className="col-md-6">
                            {social.endDate ? (
                              Math.ceil((new Date(social.endDate) - new Date()) / (1000 * 60 * 60 * 24)) > 0 && (
                                <div className="mb-2"><span style={{color: '#68778d'}}>{L.settings.expiresIn}</span> <strong style={{color: '#0a2540'}}>{L.settings.daysCount(Math.ceil((new Date(social.endDate) - new Date()) / (1000 * 60 * 60 * 24)))}</strong></div>
                              )
                            ) : social.nextChargeDate && (
                              <div className="mb-2"><span style={{color: '#68778d'}}>{L.settings.daysRemaining}</span> <strong style={{color: '#0a2540'}}>{L.settings.daysCount(social.status === 'skipped' ? 0 : Math.ceil((new Date(social.nextChargeDate) - new Date()) / (1000 * 60 * 60 * 24)))}</strong></div>
                            )}
                            {social.status === 'skipped' && (
                              <Button size="sm" onClick={() => handleTabSelect('invoices')} style={{...stripeBtn, padding: '4px 12px', fontSize: '0.78rem', background: '#059669'}}>{L.settings.payInvoice}</Button>
                            )}
                          </div>
                          {social.planName && !social.endDate && (
                            <div className="col-md-6">
                              <div className="mb-2"><span style={{color: '#68778d'}}>{L.settings.nextCharge}</span> <strong style={{color: '#0a2540'}}>{social.nextChargeDate ? new Date(social.nextChargeDate).toLocaleDateString() : L.settings.na}</strong></div>
                              <div className="mb-2"><span style={{color: '#68778d'}}>{L.settings.interval}</span> <strong style={{color: '#0a2540'}}>{(social.planInterval || L.settings.na).charAt(0).toUpperCase() + (social.planInterval || '').slice(1)}</strong></div>
                              <div className="mb-2"><span style={{color: '#68778d'}}>{L.settings.started}</span> <strong style={{color: '#0a2540'}}>{social.createdAt ? new Date(social.createdAt).toLocaleDateString() : L.settings.na}</strong></div>
                            </div>
                          )}
                        </div>

                        {/* Action buttons */}
                        <div className="d-flex flex-wrap gap-2 mt-3 pt-3" style={{borderTop: '1px solid #e3e8ee'}}>
                          {social.status === 'active' && (
                            <Dropdown className="d-inline-block" align="end" drop="up">
                              <Dropdown.Toggle variant="light" size="sm" style={{...stripeBtnLight, padding: '5px 12px', fontSize: '0.8rem'}}>
                                {social.cardid && profile.cards[social.cardid] ? (
                                  <>
                                    {profile.cards[social.cardid].cardnumber.startsWith('4') && <i className="fab fa-cc-visa me-1" style={{color: '#1a1f71'}}></i>}
                                    {profile.cards[social.cardid].cardnumber.startsWith('5') && <i className="fab fa-cc-mastercard me-1" style={{color: '#1a1f71'}}></i>}
                                    {profile.cards[social.cardid].cardnumber.startsWith('3') && <i className="fab fa-cc-amex me-1" style={{color: '#006fcf'}}></i>}
                                    •••• {profile.cards[social.cardid].cardnumber.slice(-4)}
                                  </>
                                ) : (
                                  <><i className="fas fa-credit-card me-1"></i> {L.settings.selectCard}</>
                                )}
                              </Dropdown.Toggle>
                              <Dropdown.Menu style={{maxHeight: '200px', overflowY: 'auto', borderRadius: '10px', border: '1px solid #e3e8ee', boxShadow: '0 4px 12px rgba(0,0,0,0.08)'}}>
                                {Object.entries(profile.cards).map(([cardId, card]) => (
                                  <Dropdown.Item key={cardId} onClick={() => handleCardChange(social.profileid, cardId)} active={cardId == social.cardid}
                                    style={{fontSize: '0.85rem', padding: '8px 16px', ...(cardId == social.cardid ? {background: stripePurple, color: '#fff'} : {})}}>
                                    {card.cardnumber.startsWith('4') && <i className={`fab fa-cc-visa me-2 ${cardId == social.cardid ? 'text-white' : ''}`} style={cardId != social.cardid ? {color: '#1a1f71'} : {}}></i>}
                                    {card.cardnumber.startsWith('5') && <i className={`fab fa-cc-mastercard me-2 ${cardId == social.cardid ? 'text-white' : ''}`} style={cardId != social.cardid ? {color: '#1a1f71'} : {}}></i>}
                                    {card.cardnumber.startsWith('3') && <i className={`fab fa-cc-amex me-2 ${cardId == social.cardid ? 'text-white' : ''}`} style={cardId != social.cardid ? {color: '#006fcf'} : {}}></i>}
                                    {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fas fa-credit-card me-2"></i>}
                                    •••• {card.cardnumber.slice(-4)}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                          {social.status === 'active' && social.endDate == null && (
                            <>
                              {social.planName === 'basic' && (
                                <a href="/dashboard/upgrade" className="btn btn-sm d-flex align-items-center text-decoration-none bg-instagram" style={{color: '#fff', border: 'none', borderRadius: '8px', padding: '5px 12px', fontSize: '0.8rem', fontWeight: 600, boxShadow: '0 2px 4px rgba(99,91,255,0.25)'}}>
                                  <i className="fas fa-crown me-1" style={{fontSize: '0.7rem'}}></i> {L.settings.upgradeToPro}
                                </a>
                              )}
                              {social.isPaused === 'true' ? (
                                <button className="btn btn-sm d-flex align-items-center" 
                                  onClick={() => handleToggleGrowthPause(social.profileid, true)}
                                  disabled={pauseLoadingId === social.profileid}
                                  style={{background: '#059669', color: '#fff', border: 'none', borderRadius: '6px', padding: '5px 12px', fontSize: '0.8rem', fontWeight: 600}}>
                                  <i className={`fas ${pauseLoadingId === social.profileid ? 'fa-spinner fa-spin' : 'fa-play'} me-1`}></i> {L.settings.resumeGrowth}
                                </button>
                              ) : (
                                <button className="btn btn-sm d-flex align-items-center" 
                                  onClick={() => handleToggleGrowthPause(social.profileid, false)}
                                  disabled={pauseLoadingId === social.profileid}
                                  style={{color: '#d97706', fontSize: '0.8rem', fontWeight: 500, background: 'transparent', border: '1px solid #fde68a', borderRadius: '6px', padding: '5px 12px'}}>
                                  <i className={`fas ${pauseLoadingId === social.profileid ? 'fa-spinner fa-spin' : 'fa-pause'} me-1`}></i> {L.settings.pauseGrowth}
                                </button>
                              )}
                              <button className="btn btn-sm d-flex align-items-center" onClick={() => handleOpenCancelModal(social.subscriptionid, social.planInterval, social.planName)}
                                style={{color: '#cf3033', fontSize: '0.8rem', fontWeight: 500, background: 'transparent', border: '1px solid #fecaca', borderRadius: '6px', padding: '5px 12px'}}>
                                <i className="fas fa-times me-1"></i> {L.settings.cancel}
                              </button>
                            </>
                          )}
                          {social.endDate != null && (
                            <button className="btn btn-sm d-flex align-items-center" onClick={() => handleResumeSubscription(social.subscriptionid)}
                              style={{background: '#059669', color: '#fff', border: 'none', borderRadius: '6px', padding: '5px 12px', fontSize: '0.8rem', fontWeight: 600}}>
                              <i className="fas fa-play me-1"></i> {L.settings.resume}
                            </button>
                          )}
                          {/* Buying a legacy plan is retired for one-time customers:
                              they top up and take a membership instead. Shown only to
                              accounts that already hold a legacy plan somewhere. */}
                          {social.status === 'inactive' && !social.endDate && profile?.hasActiveSubscription && (
                            <button className="btn btn-sm d-flex align-items-center gap-1"
                              onClick={async () => {
                                await axios.post("https://api.viralgpt.com/auth/select", { profileid: social.profileid }, { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
                                window.location.href = '/dashboard/upgrade';
                              }}
                              style={{background: 'linear-gradient(135deg, #635bff 0%, #8b5cf6 100%)', color: '#fff', border: 'none', borderRadius: '8px', padding: '6px 16px', fontSize: '0.8rem', fontWeight: 600, boxShadow: '0 2px 4px rgba(99,91,255,0.25)'}}>
                              <i className="fas fa-crown" style={{fontSize: '0.7rem'}}></i> {L.settings.purchasePlan}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Tab.Pane>

            {/* ===================== INVOICES TAB ===================== */}
            <Tab.Pane eventKey="invoices">
              <div style={stripeCard}>
                <div style={stripeCardHeader}>
                  <h6 style={stripeHeaderText}><i className="fas fa-file-invoice me-2" style={{color: stripePurple}}></i>{L.settings.invoiceHistory}</h6>
                </div>
                <div className="d-none d-md-block" style={{overflowX: 'auto'}}>
                  <table className="table mb-0" style={{fontSize: '0.875rem'}}>
                    <thead>
                      <tr style={{borderBottom: '1px solid #e3e8ee'}}>
                        <th style={{...stripeLabel, padding: '12px 20px', borderBottom: '1px solid #e3e8ee'}}>{L.settings.invoiceTh}</th>
                        <th style={{...stripeLabel, padding: '12px 16px', borderBottom: '1px solid #e3e8ee'}}>{L.settings.profileTh}</th>
                        <th style={{...stripeLabel, padding: '12px 16px', borderBottom: '1px solid #e3e8ee'}}>{L.settings.amountTh}</th>
                        <th style={{...stripeLabel, padding: '12px 16px', borderBottom: '1px solid #e3e8ee'}}>{L.settings.dateTh}</th>
                        <th style={{...stripeLabel, padding: '12px 16px', borderBottom: '1px solid #e3e8ee'}}>{L.settings.statusTh}</th>
                        <th style={{...stripeLabel, padding: '12px 16px', borderBottom: '1px solid #e3e8ee'}}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {profile.invoices && Object.values(profile.invoices).length > 0 ? (
                        Object.values(profile.invoices).reverse().map((invoice, index) => (
                          <tr key={index} style={{borderBottom: '1px solid #f0f2f5'}}>
                            <td style={{padding: '14px 20px', color: '#0a2540', fontWeight: 500}}>#{invoice.invoiceid}</td>
                            <td style={{padding: '14px 16px', color: '#425466'}}>{profile.socials[invoice.profileid]?.username}</td>
                            <td style={{padding: '14px 16px', color: '#0a2540', fontWeight: 600}}>${invoice.price}</td>
                            <td style={{padding: '14px 16px', color: '#68778d'}}>{new Date(invoice.createdAt).toLocaleDateString()}</td>
                            <td style={{padding: '14px 16px'}}>
                              <span style={{
                                fontSize: '0.7rem', fontWeight: 600, padding: '2px 8px', borderRadius: '4px',
                                background: invoice.status === 'paid' ? '#ecfdf5' : '#fef2f2',
                                color: invoice.status === 'paid' ? '#065f46' : '#991b1b'
                              }}>
                                {invoice.status.toUpperCase()}
                              </span>
                            </td>
                            <td style={{padding: '14px 16px'}}>
                              {invoice.status === 'unpaid' && (
                                <Button size="sm" onClick={() => { setSelectedInvoice(invoice); setShowPayInvoiceModal(true); }}
                                  style={{...stripeBtn, padding: '4px 12px', fontSize: '0.78rem', background: '#059669'}}>
                                  {L.settings.payNow}
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center" style={{padding: '40px 20px', color: '#68778d'}}>
                            <i className="fas fa-file-invoice" style={{fontSize: '2rem', color: '#c1c9d2', display: 'block', marginBottom: '8px'}}></i>
                            {L.settings.noInvoicesFound}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {/* Mobile invoice cards */}
                <div className="d-md-none p-3">
                  {profile.invoices && Object.values(profile.invoices).length > 0 ? (
                    <div className="d-flex flex-column gap-3">
                      {Object.values(profile.invoices).reverse().map((invoice, index) => (
                        <div key={index} style={{background: '#f6f9fc', borderRadius: '10px', border: '1px solid #e3e8ee', padding: '14px'}}>
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <div style={{fontWeight: 600, color: '#0a2540', fontSize: '0.9rem'}}>{L.settings.invoiceNum(invoice.invoiceid)}</div>
                              <div style={{color: '#425466', fontSize: '0.82rem'}}>{profile.socials[invoice.profileid]?.username}</div>
                            </div>
                            <span style={{
                              fontSize: '0.7rem', fontWeight: 600, padding: '2px 8px', borderRadius: '4px',
                              background: invoice.status === 'paid' ? '#ecfdf5' : '#fef2f2',
                              color: invoice.status === 'paid' ? '#065f46' : '#991b1b'
                            }}>
                              {invoice.status.toUpperCase()}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <span style={{color: '#0a2540', fontWeight: 600, fontSize: '1rem'}}>${invoice.price}</span>
                              <span style={{color: '#68778d', fontSize: '0.8rem', marginLeft: '8px'}}>{new Date(invoice.createdAt).toLocaleDateString()}</span>
                            </div>
                            {invoice.status === 'unpaid' && (
                              <Button size="sm" onClick={() => { setSelectedInvoice(invoice); setShowPayInvoiceModal(true); }}
                                style={{...stripeBtn, padding: '6px 16px', fontSize: '0.82rem', background: '#059669'}}>
                                {L.settings.payNow}
                              </Button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center" style={{padding: '40px 20px', color: '#68778d'}}>
                      <i className="fas fa-file-invoice" style={{fontSize: '2rem', color: '#c1c9d2', display: 'block', marginBottom: '8px'}}></i>
                      {L.settings.noInvoicesFound}
                    </div>
                  )}
                </div>
              </div>
            </Tab.Pane>

            {/* ===================== REFILLS TAB ===================== */}
            <Tab.Pane eventKey="refills">
              <div style={stripeCard}>
                <div style={stripeCardHeader}>
                  <h6 style={stripeHeaderText}><i className="fas fa-redo me-2" style={{color: stripePurple}}></i>{L.settings.requestRefillTitle}</h6>
                </div>
                <div className="p-4">
                  <p style={{color: '#425466', fontSize: '0.9rem', marginBottom: '20px'}}>
                    {L.settings.refillDesc1}<br/>
                    <span style={{color: '#68778d', fontSize: '0.82rem'}}>{L.settings.refillDesc2}</span>
                  </p>

                  <Form.Group className="mb-3">
                    <Form.Label style={stripeLabel}>{L.settings.selectProfile}</Form.Label>
                    <Form.Select value={selectedProfileId} onChange={(e) => setSelectedProfileId(e.target.value)} style={stripeInput}>
                      <option value="">{L.settings.chooseProfile}</option>
                      {profile.socials && Object.entries(profile.socials).map(([id, social]) => (
                        <option key={id} value={id}>{social.platform} — {social.username}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Button onClick={() => handleLookupRefill(selectedProfileId)} disabled={!selectedProfileId || isScanning} style={stripeBtn}>
                    <i className={`fas ${isScanning ? 'fa-spinner fa-spin' : 'fa-search'} me-2`}></i>{isScanning ? L.settings.scanning : L.settings.scanProfile}
                  </Button>

                  {/* Refill Results */}
                  {missingFollowers !== null && (
                    <div className="mt-4" style={{background: '#f6f9fc', borderRadius: '10px', border: '1px solid #e3e8ee', overflow: 'hidden'}}>
                      <div className="px-4 py-3 d-flex align-items-center gap-3" style={{borderBottom: '1px solid #e3e8ee'}}>
                        {profilePhotoMissing && (
                          <img src={profilePhotoMissing} alt="Profile" className="rounded-circle" style={{width: '40px', height: '40px', objectFit: 'cover'}} />
                        )}
                        <h6 style={{...stripeHeaderText, fontSize: '0.9rem'}}><i className="fas fa-chart-line me-2" style={{color: stripePurple}}></i>{L.settings.scanResults}</h6>
                      </div>
                      <div className="p-4">
                        {missingFollowers <= 0 ? (
                          <div>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <i className="fas fa-check-circle" style={{color: '#059669', fontSize: '1.2rem'}}></i>
                              <span style={{fontWeight: 600, color: '#065f46'}}>{L.settings.noMissingFollowers}</span>
                            </div>
                            <div className="d-flex gap-4" style={{fontSize: '0.85rem'}}>
                              <div><span style={{color: '#68778d'}}>{L.settings.current}</span><br/><strong style={{color: '#0a2540'}}>{(currentFollowers || 0).toLocaleString()}</strong></div>
                              <div><span style={{color: '#68778d'}}>{L.settings.gainedVia}</span><br/><strong style={{color: stripePurple}}>+{(deliveredFollowers || Math.abs(missingFollowers || 0)).toLocaleString()}</strong></div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="d-flex align-items-center gap-2 mb-3">
                              <i className="fas fa-exclamation-triangle" style={{color: '#dc2626', fontSize: '1.2rem'}}></i>
                              <span style={{fontWeight: 600, color: '#991b1b'}}>{L.settings.missingCount((missingFollowers || 0).toLocaleString())}</span>
                            </div>
                            <div className="d-flex gap-4 mb-3" style={{fontSize: '0.85rem'}}>
                              <div><span style={{color: '#68778d'}}>{L.settings.expected}</span><br/><strong style={{color: '#0a2540'}}>{(expectedFollowers || 0).toLocaleString()}</strong></div>
                              <div><span style={{color: '#68778d'}}>{L.settings.current}</span><br/><strong style={{color: '#0a2540'}}>{(currentFollowers || 0).toLocaleString()}</strong></div>
                              <div><span style={{color: '#68778d'}}>{L.settings.missing}</span><br/><strong style={{color: '#dc2626'}}>{(missingFollowers || 0).toLocaleString()}</strong></div>
                            </div>
                            {refillEligible === false ? (
                              <div style={{fontSize: '0.85rem', color: '#68778d'}}>{L.settings.refillNotYet}</div>
                            ) : (
                              <Button onClick={() => handleRequestRefill(selectedProfileId)} disabled={isSubmittingRefill} style={{...stripeBtn, background: '#059669', opacity: isSubmittingRefill ? 0.7 : 1}}>
                                {isSubmittingRefill ? <><i className="fas fa-spinner fa-spin me-2"></i>{L.settings.submitting}</> : <><i className="fas fa-sync-alt me-2"></i>{L.settings.requestFollowerRefill}</>}
                              </Button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Tab.Pane>

          </Tab.Content>
        </Tab.Container>
      </Container>
      </div>

      {/* ===================== MODALS ===================== */}

      {/* Pay Invoice Modal */}
      <Modal show={showPayInvoiceModal} onHide={() => setShowPayInvoiceModal(false)} centered>
        <Modal.Header closeButton style={{borderBottom: '1px solid #e3e8ee'}}>
          <Modal.Title style={{fontSize: '1.1rem', fontWeight: 600, color: '#0a2540'}}>{L.settings.payInvoiceTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="p-3 mb-4" style={{background: '#eff6ff', borderRadius: '10px', border: '1px solid #bfdbfe'}}>
            <i className="fas fa-info-circle me-2" style={{color: '#2563eb'}}></i>
            <span style={{color: '#1e40af', fontSize: '0.875rem'}}>{L.settings.reactivateNote}</span>
          </div>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={stripeLabel}>{L.settings.paymentMethod}</Form.Label>
              <div className="d-flex flex-column gap-2" style={{maxHeight: '260px', overflowY: 'auto'}}>
                {Object.entries(profile.cards).map(([id, card]) => (
                  <div key={id} className="d-flex align-items-center gap-3 p-3 cursor-pointer" onClick={() => setSelectedCard(id)}
                    style={{background: selectedCard === id ? '#f0ebff' : '#f6f9fc', borderRadius: '10px', border: selectedCard === id ? `2px solid ${stripePurple}` : '1px solid #e3e8ee', cursor: 'pointer'}}>
                    <div style={{width: '36px', height: '24px', background: '#fff', borderRadius: '4px', border: '1px solid #e3e8ee', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      {card.cardnumber.startsWith('4') && <i className="fab fa-cc-visa" style={{color: '#1a1f71'}}></i>}
                      {card.cardnumber.startsWith('5') && <i className="fab fa-cc-mastercard" style={{color: '#1a1f71'}}></i>}
                      {card.cardnumber.startsWith('3') && <i className="fab fa-cc-amex" style={{color: '#006fcf'}}></i>}
                      {!card.cardnumber.startsWith('3') && !card.cardnumber.startsWith('4') && !card.cardnumber.startsWith('5') && <i className="fas fa-credit-card" style={{color: '#68778d'}}></i>}
                    </div>
                    <span style={{fontWeight: 500, color: '#0a2540', fontSize: '0.9rem'}}>•••• {card.cardnumber.slice(-4)} ({card.exp})</span>
                  </div>
                ))}
                <div className="d-flex align-items-center gap-3 p-3 cursor-pointer" onClick={() => setSelectedCard('addCard')}
                  style={{background: selectedCard === 'addCard' ? '#f0ebff' : '#f6f9fc', borderRadius: '10px', border: selectedCard === 'addCard' ? `2px solid ${stripePurple}` : '1px solid #e3e8ee', cursor: 'pointer'}}>
                  <div style={{width: '36px', height: '24px', background: '#fff', borderRadius: '4px', border: '1px solid #e3e8ee', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="fas fa-plus" style={{color: stripePurple, fontSize: '0.7rem'}}></i>
                  </div>
                  <span style={{fontWeight: 500, color: '#0a2540', fontSize: '0.9rem'}}>{L.settings.addNewCard}</span>
                </div>
              </div>
            </Form.Group>

            {(Object.keys(profile.cards).length === 0 || selectedCard === 'addCard') && (
              <div>
                <InputGroup className="mb-3">
                  <InputGroup.Text style={{background: '#f6f9fc', border: '1px solid #e3e8ee'}}><i className="fas fa-credit-card" style={{color: stripePurple}}></i></InputGroup.Text>
                  <Form.Control as={InputMask} type="text" ref={cardRef} placeholder={L.settings.cardNumberPh} mask="9999 9999 9999 9999" maskChar="" required style={{border: '1px solid #e3e8ee'}} />
                </InputGroup>
                <div className="d-flex gap-3 mb-3">
                  <InputGroup>
                    <InputGroup.Text style={{background: '#f6f9fc', border: '1px solid #e3e8ee'}}><i className="fas fa-calendar" style={{color: stripePurple}}></i></InputGroup.Text>
                    <Form.Control as={InputMask} maskChar="" type="text" ref={expRef} placeholder="MM/YY" mask="99/99" required style={{border: '1px solid #e3e8ee'}} />
                  </InputGroup>
                  <InputGroup>
                    <InputGroup.Text style={{background: '#f6f9fc', border: '1px solid #e3e8ee'}}><i className="fas fa-lock" style={{color: stripePurple}}></i></InputGroup.Text>
                    <Form.Control as={InputMask} maskChar="" type="text" ref={cvvRef} placeholder={L.settings.cvvPh} mask="9999" required style={{border: '1px solid #e3e8ee'}} />
                  </InputGroup>
                </div>
              </div>
            )}

            <Button className="w-100" disabled={isLoading} onClick={() => handlePayInvoice(selectedInvoice?.invoiceid, selectedCard, expRef.current?.value, cvvRef.current?.value, cardRef.current?.value)}
              style={{...stripeBtn, padding: '12px', width: '100%'}}>
              {isLoading ? L.settings.processing : L.settings.payAmount(selectedInvoice?.price)}
            </Button>
            <div className="mt-3">
              {window.location.hostname !== 'localhost' && <div id="applepaybutton"></div>}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Add Card Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton style={{borderBottom: '1px solid #e3e8ee'}}>
          <Modal.Title style={{fontSize: '1.1rem', fontWeight: 600, color: '#0a2540'}}>{L.settings.addPaymentMethod}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={stripeLabel}>{L.settings.cardNumber}</Form.Label>
              <Form.Control as={InputMask} type="text" placeholder="•••• •••• •••• ••••" maskChar="" mask="9999 9999 9999 9999" onChange={(e) => setCardNumber(e.target.value)} style={stripeInput} />
            </Form.Group>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label style={stripeLabel}>{L.settings.expiration}</Form.Label>
                  <Form.Control as={InputMask} maskChar="" type="text" placeholder="MM/YY" mask="99/99" onChange={(e) => setCardExpiry(e.target.value)} style={stripeInput} />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label style={stripeLabel}>{L.settings.cvc}</Form.Label>
                  <Form.Control as={InputMask} maskChar="" type="text" placeholder="•••" mask="999" onChange={(e) => setCardCvc(e.target.value)} style={stripeInput} />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{borderTop: '1px solid #e3e8ee'}}>
          <Button variant="light" onClick={handleCloseModal} style={stripeBtnLight}>{L.settings.cancel}</Button>
          <Button onClick={handleSaveBilling} disabled={isAddingCard} style={stripeBtn}><i className="fas fa-plus me-2"></i>{L.settings.addCard}</Button>
        </Modal.Footer>
      </Modal>

      {/* Add Profile Modal */}
      <Modal show={showAddProfile} onHide={() => setShowAddProfile(false)} centered size="lg">
        <Modal.Header closeButton style={{borderBottom: '1px solid #e3e8ee'}}>
          <Modal.Title style={{fontSize: '1.1rem', fontWeight: 600, color: '#0a2540'}}>{L.settings.linkAccount}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterSocial show={showAddProfile} onHide={() => setShowAddProfile(false)} />
        </Modal.Body>
      </Modal>

      {/* Unlink Modal */}
      <Modal show={showUnlinkModal} onHide={() => setShowUnlinkModal(false)} centered>
        <Modal.Header closeButton style={{borderBottom: '1px solid #e3e8ee'}}>
          <Modal.Title style={{fontSize: '1.1rem', fontWeight: 600, color: '#0a2540'}}>{L.settings.unlinkAccount}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4 px-4">
          <p style={{color: '#425466', margin: 0}}>{L.settings.unlinkConfirm(unlinkProfileName)}</p>
        </Modal.Body>
        <Modal.Footer style={{borderTop: '1px solid #e3e8ee'}}>
          <Button variant="light" onClick={() => setShowUnlinkModal(false)} style={stripeBtnLight}>{L.settings.cancel}</Button>
          <Button onClick={() => unlinkAccount(unlinkProfile)} style={{...stripeBtn, background: '#cf3033'}}>{L.settings.unlinkProfileBtn}</Button>
        </Modal.Footer>
      </Modal>

      {/* Cancel Subscription Modal */}
      <Modal show={showCancelModal} onHide={handleCloseCancelModal} centered>
        <Modal.Header closeButton style={{borderBottom: '1px solid #e3e8ee'}}>
          <Modal.Title style={{fontSize: '1.1rem', fontWeight: 600, color: '#0a2540'}}>{L.settings.cancelSubscription}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p style={{color: '#425466', fontSize: '0.9rem', marginBottom: '16px'}}>{L.settings.cancelWhy}</p>
          <Form.Group className="mb-3">
            <Form.Label style={stripeLabel}>{L.settings.reason} <span style={{color: '#cf3033'}}>*</span></Form.Label>
            <Form.Select value={cancelReasonType} onChange={(e) => setCancelReasonType(e.target.value)} style={stripeInput}>
              <option value="">{L.settings.selectReason}</option>
              <option value="missing_followers">{L.settings.reasonMissingFollowers}</option>
              <option value="price_too_high">{L.settings.reasonPriceTooHigh}</option>
              {cancelSubInterval === "annual" && <option value="accidental_annual">{L.settings.reasonAccidentalAnnual}</option>}
              {cancelSubInterval === "annual" && <option value="switch_monthly">{L.settings.reasonSwitchMonthly}</option>}
              <option value="other">{L.settings.reasonOther}</option>
            </Form.Select>
          </Form.Group>

          {cancelReasonType === "missing_followers" && (
            <div className="p-3" style={{background: '#eff6ff', borderRadius: '10px', border: '1px solid #bfdbfe'}}>
              <p style={{color: '#1e40af', fontSize: '0.875rem', marginBottom: '10px'}}>{L.settings.refillOffer}</p>
              <Button size="sm" onClick={() => handleTabSelect('refills')} style={{...stripeBtn, fontSize: '0.8rem', padding: '6px 14px'}}>
                <i className="fas fa-redo me-2"></i>{L.settings.goToRefills}
              </Button>
            </div>
          )}

          {cancelReasonType === "price_too_high" && (
            <div className="p-3" style={{background: '#ecfdf5', borderRadius: '10px', border: '1px solid #a7f3d0'}}>
              <p style={{color: '#065f46', fontSize: '0.875rem', marginBottom: '10px'}}>{L.settings.bonusOffer}</p>
              <Button size="sm" onClick={handleFreeBalance} style={{...stripeBtn, fontSize: '0.8rem', padding: '6px 14px', background: '#059669'}}>
                <i className="fas fa-gift me-2"></i>{L.settings.getFreeBalance}
              </Button>
              {cancelSubInterval === "annual" && (
                <div style={{marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #a7f3d0'}}>
                  <p style={{color: '#065f46', fontSize: '0.875rem', marginBottom: '10px'}}>{L.settings.switchMonthlyOffer(cancelSubPlan === 'pro' ? '199' : cancelSubPlan === 'basic' ? '59' : '29')}</p>
                  <Button size="sm" onClick={handleSwitchToMonthly} disabled={switchingToMonthly} style={{...stripeBtn, fontSize: '0.8rem', padding: '6px 14px', background: '#635bff'}}>
                    <i className="fas fa-exchange-alt me-2"></i>{switchingToMonthly ? L.settings.switching : L.settings.switchToMonthly}
                  </Button>
                </div>
              )}
            </div>
          )}

          {cancelReasonType === "accidental_annual" && cancelSubInterval === "annual" && (() => {
            const monthlyPrices = { starter: 29, basic: 59, pro: 199 };
            const monthlyPrice = monthlyPrices[cancelSubPlan] || 0;
            // We need to estimate the annual price — use known plan prices
            const annualPrices = { starter: 168, basic: 348, pro: 1188 };
            const annualPrice = annualPrices[cancelSubPlan] || 0;
            const refundDiff = parseFloat((annualPrice - monthlyPrice).toFixed(2));
            return (
              <div className="p-3" style={{background: '#ecfdf5', borderRadius: '10px', border: '1px solid #a7f3d0'}}>
                <p style={{color: '#065f46', fontSize: '0.875rem', fontWeight: 600, marginBottom: '6px'}}>{L.settings.switchRefundTitle}</p>
                <p style={{color: '#065f46', fontSize: '0.84rem', marginBottom: '10px'}}>
                  {L.settings.refundExplain(refundDiff, annualPrice, monthlyPrice)}
                </p>
                <div style={{background: '#f0fdf4', borderRadius: '6px', padding: '8px 12px', marginBottom: '12px', fontSize: '0.82rem', color: '#065f46'}}>
                  <div className="d-flex justify-content-between"><span>{L.settings.annualChargePaid}</span><strong>${annualPrice}</strong></div>
                  <div className="d-flex justify-content-between"><span>{L.settings.newMonthlyRate}</span><strong>{L.settings.perMo(monthlyPrice)}</strong></div>
                  <hr style={{margin: '4px 0', borderColor: '#a7f3d0'}} />
                  <div className="d-flex justify-content-between"><span>{L.settings.refundToCard}</span><strong style={{color: '#059669'}}>${refundDiff}</strong></div>
                </div>
                <Button size="sm" onClick={handleAccidentalAnnualSwitch} disabled={switchingToMonthly} style={{...stripeBtn, fontSize: '0.8rem', padding: '8px 18px', background: '#059669'}}>
                  <i className="fas fa-exchange-alt me-2"></i>{switchingToMonthly ? L.settings.processing : L.settings.refundAndSwitch(refundDiff)}
                </Button>
              </div>
            );
          })()}

          {cancelReasonType === "switch_monthly" && cancelSubInterval === "annual" && (
            <div className="p-3" style={{background: '#eff6ff', borderRadius: '10px', border: '1px solid #bfdbfe'}}>
              <p style={{color: '#1e40af', fontSize: '0.875rem', fontWeight: 600, marginBottom: '6px'}}>{L.settings.switchToMonthlyBilling}</p>
              <p style={{color: '#1e40af', fontSize: '0.84rem', marginBottom: '12px'}}>
                {L.settings.keepPlanOffer(cancelSubPlan?.charAt(0).toUpperCase() + cancelSubPlan?.slice(1), cancelSubPlan === 'pro' ? '199' : cancelSubPlan === 'basic' ? '59' : '29')}
              </p>
              <Button size="sm" onClick={handleSwitchToMonthly} disabled={switchingToMonthly} style={{...stripeBtn, fontSize: '0.8rem', padding: '8px 18px', background: '#635bff'}}>
                <i className="fas fa-exchange-alt me-2"></i>{switchingToMonthly ? L.settings.switching : L.settings.switchToMonthlyBilling}
              </Button>
            </div>
          )}

          {cancelReasonType === "other" && (
            <Form.Group className="mb-3">
              <Form.Label style={stripeLabel}>{L.settings.details} <span style={{color: '#cf3033'}}>*</span></Form.Label>
              <Form.Control as="textarea" rows={3} placeholder={L.settings.detailsPlaceholder} value={cancelReason} onChange={(e) => setCancelReason(e.target.value)}
                isInvalid={cancelReason.length > 0 && cancelReason.length < 15} style={stripeInput} />
              <Form.Control.Feedback type="invalid">{L.settings.provide15}</Form.Control.Feedback>
              <Form.Text style={{color: '#68778d', fontSize: '0.78rem'}}>{L.settings.charsMin}</Form.Text>
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer style={{borderTop: '1px solid #e3e8ee'}}>
          {cancelReasonType === "other" && (
            <>
              <Button variant="light" onClick={handleCloseCancelModal} style={stripeBtnLight}>{L.settings.keepSubscription}</Button>
              <Button onClick={() => handlePauseSubscription(selectedSubscriptionId)} disabled={cancelReason.length < 15}
                style={{...stripeBtn, background: '#cf3033'}}>{L.settings.cancelSubscription}</Button>
            </>
          )}
          {(!cancelReasonType || ["missing_followers", "price_too_high", "accidental_annual", "switch_monthly"].includes(cancelReasonType)) && (
            <Button variant="light" onClick={handleCloseCancelModal} style={stripeBtnLight}>{cancelReasonType ? L.settings.keepSubscription : L.settings.close}</Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Change Password Modal */}
      <Modal show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)} centered>
        <Modal.Header closeButton style={{borderBottom: '1px solid #e3e8ee'}}>
          <Modal.Title style={{fontSize: '1.1rem', fontWeight: 600, color: '#0a2540'}}>{L.settings.changePassword}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form>
			{needsPasswordSetup ? (
				<div className="alert alert-info py-2" style={{fontSize: '0.9rem'}}>{L.settings.passwordSetupHint}</div>
			) : (
				<Form.Group className="mb-3">
					<Form.Label style={stripeLabel}>{L.settings.currentPassword}</Form.Label>
					<Form.Control type="password" placeholder={L.settings.enterCurrentPassword} onChange={(e) => setOldPassword(e.target.value)} style={stripeInput} />
				</Form.Group>
			)}
            <Form.Group className="mb-3">
              <Form.Label style={stripeLabel}>{L.settings.newPassword}</Form.Label>
              <Form.Control type="password" placeholder={L.settings.enterNewPassword} onChange={(e) => setNewPassword(e.target.value)} style={stripeInput} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={stripeLabel}>{L.settings.confirmNewPassword}</Form.Label>
              <Form.Control type="password" placeholder={L.settings.confirmNewPasswordPh} onChange={(e) => setConfirmPassword(e.target.value)} style={stripeInput} />
            </Form.Group>
            <Button onClick={handleSubmitPasswordChange} style={stripeBtn}>{L.settings.savePassword}</Button>
          </Form>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Settings;
